import { render, staticRenderFns } from "./EighthComponent.vue?vue&type=template&id=52e24823"
import script from "./EighthComponent.vue?vue&type=script&lang=js"
export * from "./EighthComponent.vue?vue&type=script&lang=js"
import style0 from "./EighthComponent.vue?vue&type=style&index=0&id=52e24823&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports